
export const buildPassengerRequest = ({ clientCode, key, referenceNo, contactDetails, travellers, ssrInfo, pricing, userName, seatSelections, selectedMeal, selectedBaggage, companyMarkup, customField }) => {
  // const allPassengers = [
  //   ...(travellers?.adults || []),
  //   ...(travellers?.children || []),
  //   ...(travellers?.infants || []),
  // ];
  const allPassengers = [
    ...(travellers?.adults?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "ADT",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
    })) || []),

    ...(travellers?.children?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "CHD",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
    })) || []),

    ...(travellers?.infants?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "INF",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
    })) || []),
  ];

  const mapPaxType = (type) => {
    if (type === "ADULT") return "ADT";
    if (type === "CHILD") return "CHD";
    if (type === "INFANT") return "INF";
    return type;
  };

  const getGlobalPaxNumber = (type, paxNumber) => {
    const targetType = mapPaxType(type);

    let countWithinType = -1;

    for (let i = 0; i < allPassengers.length; i++) {
      if (allPassengers[i].paxType === targetType) {
        countWithinType++;

        if (countWithinType === Number(paxNumber)) {
          return (i + 1).toString();
        }
      }
    }

    return "1";
  };

  const buildSeatSSR = (seatSelections) => {
    const ssr = [];

    Object.entries(seatSelections || {}).forEach(([trackID, paxTypes]) => {
      const [departureStation, arrivalStation, , segtrackID] = trackID.split("_");

      Object.entries(paxTypes).forEach(([paxType, paxList]) => {
        Object.entries(paxList).forEach(([paxNumber, seat]) => {
          ssr.push({
            trackID: segtrackID,
            //paxNumber: (Number(paxNumber) + 1).toString(),
            paxNumber: getGlobalPaxNumber(paxType, paxNumber),
            //tripType: "ONEWAY",
            ssrCode: seat.seatCode,
            ssrPrice: seat.price.toString(),
            departureStation,
            arrivalStation,
            ssrType: "Seat",
            paxType: mapPaxType(paxType)
          });
        });
      });
    });

    return ssr;
  };


  const buildBaggageSSR = (selectedBaggage) => {
    const ssr = [];
    Object.entries(selectedBaggage || {}).forEach(([key, item]) => {
      const [, , trackID, paxType, paxNumber, ssrCode] = key.split("_");

      ssr.push({
        trackID: trackID,
        paxNumber: getGlobalPaxNumber(paxType, paxNumber),
        //tripType: "ONEWAY",
        ssrCode: ssrCode,
        ssrPrice: item.price.toString(),
        departureStation: item.origin,
        arrivalStation: item.destination,
        ssrType: "Baggage",
        paxType: mapPaxType(paxType)
      });
    });

    return ssr;
  };


  const buildMealSSR = (selectedMeal) => {
    const ssr = [];
    Object.entries(selectedMeal || {}).forEach(([key, item]) => {
      const [, , trackID, paxType, paxNumber, ssrCode] = key.split("_");

      ssr.push({
        trackID: trackID,
        paxNumber: getGlobalPaxNumber(paxType, paxNumber),
        //tripType: "ONEWAY",
        ssrCode: ssrCode,
        ssrPrice: item.price.toString(),
        departureStation: item.origin,
        arrivalStation: item.destination,
        ssrType: "Meal",
        paxType: mapPaxType(paxType)
      });
    });

    return ssr;
  };

  const seatSSR = buildSeatSSR(seatSelections);
  const baggageSSR = buildBaggageSSR(selectedBaggage);
  const mealSSR = buildMealSSR(selectedMeal);

  const finalSSR = [
    ...seatSSR,
    ...baggageSSR,
    ...mealSSR
  ];


  return {
    clientCode,
    key,
    referenceNo,
    customerInfo: {
      userID: contactDetails.userID,
      email: contactDetails.emailId,
      mobileCountryCode: contactDetails.countryCode,
      mobile: contactDetails.mobile,
      address: "",
      userID: userName,
      passengerDetails: allPassengers,
    },
    ssrInfo: finalSSR,
    totalAmount: pricing?.totalAmount || 0,
    ssrAmount: pricing?.ssrAmount || 0,
    discount: pricing?.discount || 0,
    grandTotalFare: pricing?.grandTotalFare || 0,
    companyMarkup: Number(companyMarkup || 0),
    //isGSTProvided: pricing?.isGSTMandatory,
    isGSTProvided: true,
    gstDetails: {
      clientCode: clientCode,
      key: key,
      referenceNo: referenceNo,
      gstNumber: contactDetails.gstNumber || "",
      name: contactDetails.gstName || "",
      email: contactDetails.emailOngst || "",
      address: contactDetails.addressOnGst || "",
      contactNo: contactDetails.phoneOnGst || "",
    },
    isSendBookingDetailOnWhatsApp: false,
    customField1: customField?.ref1 || "",
    customField2: customField?.ref2 || "",
    customField3: customField?.ref3 || "",
  };
};
